<p-toast [sticky]="false"></p-toast>

<p-confirmDialog></p-confirmDialog>
<nav-bar></nav-bar>

<div>
  <div class="header-fixed-top row" [ngClass]="{'empty': isAssistanceCasesEmpty() != true ? true : false}"
    *ngIf="!showDialog">
    <div class="col pe-0 div-bar">
      <div class="align-left">
        <app-search-case (onSelect)="selectCase($event)" (onClear)="clearCase()" (onQuery)="onQueryMember($event)"
          [clear]="caseSearchClear">
        </app-search-case>
        <img alt="" class="img-fluid ms-1"
          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/filter_white.svg' | company"
          (click)="showModalFilter()" style="width: 1.5rem; aspect-ratio: 1/1; cursor: pointer;">
        <strong style="margin: 7px 4px; color: #FFF;">
          ({{ totalCount }})
        </strong>
      </div>
      <div class="buttons-interact" style="min-width: fit-content;">
        <button type="button" class="btn btn-light btn primary-btn btn-bar" (click)="showModalSave()"
          *ngIf="isAssistanceCasesEmpty() && iAm(['admin', 'assistance_admin', 'supervisor', 'operator', 'operator_reimbursement'])"
          style="border: 1px solid #fff !important;">
          {{ 'Create Assistance Case' | translate }}
        </button>
        <button *ngIf="iAm(['admin', 'assistance_admin', 'supervisor', 'quality', 'networkleader'])"
          class="btn primary-btn ms-2 btn-bar" (click)="downloadCsv()" style="border: 1px solid #fff !important;">
          {{ 'Download Report' | translate }}
        </button>
      </div>
      <div class="button-menu">
        <nav>
          <input class="inputMenu" type="checkbox" id="menu">
          <label for="menu" class="label-menu button-menu"> ☰ </label>
          <ul>
            <li (click)="showModalSave()">{{ 'Create Assistance Case' | translate }}</li>
            <li routerLink="/admin/assistance/case/survey">{{ 'Survey QA' | translate }}</li>
            <li (click)="downloadCsv()">{{ 'Download Report' | translate }}</li>
          </ul>
        </nav>
      </div>

    </div>

  </div>

  <div class="header-fixed-top" *ngIf="showDialog">
    <h1 class="h1-header"><strong>{{ messageHeader | translate }}</strong></h1>
  </div>

  <!-- Cases -->
  <div class="cases-from-list" *ngIf="isAssistanceCasesEmpty() && !showDialog">
    <div>
      <div *ngFor="let assistancecase of assistancecases">
        <div style="display: none;"
          [ngClass]="{'display': getTicketsAssistanceCase(assistancecase) != undefined ? false: false}"></div>
        <!-- Card Black -->
        <div class="card" [ngClass]="{'blue': getColorValue(assistancecase.id) == 'blue' && assistancecase.status == 1 ? true : false,
                                      'red_': getColorValue(assistancecase.id) == 'red' && assistancecase.status == 1 ? true : false,
                                      'yellow_': getColorValue(assistancecase.id) == 'yellow' && assistancecase.status == 1 ? true : false,
                                      'black': getColorValue(assistancecase.id) == 'black' && assistancecase.status == 1 ? true : false,
                                      'grey': getColorValue(assistancecase.id) == 'grey' && assistancecase.status == 1 ? true : false,
                                      
                                      'blue-cl': getColorValue(assistancecase.id) == 'blue' && assistancecase.status == 2 ? true : false,
                                      'red-cl': getColorValue(assistancecase.id) == 'red' && assistancecase.status == 2 ? true : false,
                                      'yellow-cl': getColorValue(assistancecase.id) == 'yellow' && assistancecase.status == 2 ? true : false,
                                      'black-cl': getColorValue(assistancecase.id) == 'black' && assistancecase.status == 2 ? true : false
                                    }">
          <div class="card-body">
            <table class="table-casses" aria-label="attendancetable">
              <th scope="col"></th>

              <tr class="end-card">
                <td class="top-card">
                  <p class="space-medium"><strong>{{ 'Attendance data' | translate }}</strong></p>
                  <div class="center-data">
                    <p>
                      <img alt="" *ngIf="assistancecase.services[0].id == 332"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-grua.svg' | company">
                      <img alt="" *ngIf="assistancecase.services[0].id == 333"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-llanta.svg' | company">
                      <img alt="" *ngIf="assistancecase.services[0].id == 334"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-corriente.svg' | company">
                      <img alt="" *ngIf="assistancecase.services[0].id == 335"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-gas.svg' | company">
                      <img alt="" *ngIf="assistancecase.services[0].id == 336"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-llave.svg' | company">
                      {{ assistancecase.services ? assistancecase.services[0].name : '' }}
                    </p>
                    <p>
                      {{ assistancecase.plan ? assistancecase.plan.name : '' }}
                    </p>
                  </div>
                  <div class="center-data mt-2">
                    <div style="margin-bottom: 6px;" *ngFor="let service of assistancecase.services">
                      <strong style="
                        background-color: #0277BD;color: #FFF;padding: 2px 12px;font-size: 13px;border-radius: 10px;"
                        *ngIf="service.ticket_type">
                        {{ service.ticket_type | translate }}
                      </strong>
                      <br>
                    </div>
                    <div style="margin-bottom: 6px;" *ngIf="assistancecase.status == 2">
                      <strong
                        style="
                        background-color: #d02d24c7;color: #FFF;padding: 2px 12px;font-size: 13px;border-radius: 10px;">
                        {{ 'Closed' | translate }}
                      </strong>
                      <br>
                    </div>
                  </div>
                </td>

                <!-- Datos Gestion -->
                <td class="top-card">
                  <div class="row" style="width: inherit; margin-right: 0px !important; margin-left: auto;">
                    <div class="col-1">
                      <img alt=""
                        *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id, assistancecase.services[0].is_from_app) == 1"
                        class="bandera-position"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_roja.svg' | company">
                      <img alt=""
                        *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id, assistancecase.services[0].is_from_app) == 2"
                        class="bandera-position"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_morada.svg' | company">
                      <img alt=""
                        *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id, assistancecase.services[0].is_from_app) == 3"
                        class="bandera-position"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_verde.svg' | company">
                      <img alt=""
                        *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id, assistancecase.services[0].is_from_app) == 4"
                        class="bandera-position"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_roja_phone.svg' | company">
                      <img alt=""
                        *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id, assistancecase.services[0].is_from_app) == 5"
                        class="bandera-position"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_morada_phone.svg' | company">
                      <img alt=""
                        *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id, assistancecase.services[0].is_from_app) == 6"
                        class="bandera-position"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_verde_phone.svg' | company">
                      <img alt=""
                        *ngIf="validateColor(assistancecase.services,assistancecase.programmed_datetime,assistancecase.plan,assistancecase.country.id, assistancecase.services[0].is_from_app) == 7"
                        class="bandera-position"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/bandera_celeste_phone.svg' | company">

                      <app-flags [country]="assistancecase.country"></app-flags>
                    </div>
                    <div class="col-6">
                      <p><strong>{{ 'Management data' | translate }} #{{assistancecase.id}}</strong></p>
                    </div>
                    <div class="col-5" style="display: flex; justify-content: center;">
                      <p><strong>{{ assistancecase.date_start | currentDate: {hourTimeZone} | date: 'dd-MM-yyyy HH:mm'
                          }}</strong></p>

                    </div>
                  </div>
                  <div class="center-data">
                    <p [ngClass]="{'green_': assistancecase.created_by ? false : true}"
                      *ngIf="assistancecase.created_by_user ? true : false">
                      {{ 'Operator' | translate }} : {{ assistancecase.created_by_user ?
                      assistancecase.created_by_user.email : '' }}
                    </p>
                    <p [ngClass]="{'green_': assistancecase.created_by ? true : false}"
                      *ngIf="assistancecase.created_by ? true : false">
                      {{ 'Dispatcher' | translate }} : {{ assistancecase.created_by ? assistancecase.created_by.email :
                      '' }}
                    </p>
                  </div>
                  <div class="center-data">
                    <p *ngIf="assistancecase.sds_sinister_claim_id">
                      {{ 'Sinister Number' | translate }}:
                      <strong>
                        {{ assistancecase.sds_sinister_claim_id }}
                      </strong>
                    </p>
                  </div>
                </td>

                <td class="top-card" style="padding-right: 2.5rem;">

                  <div
                    *ngIf="assistancecase.reassigned_operator_case || assistancecase.reassigned_dispatcher_case || assistancecase.reassigned_tracking_case"
                    class="reassigned_user_case" title="{{ 'Reassigned user case' | translate }}">
                    <i class="fas fa-user-friends" aria-hidden="true"></i>
                  </div>


                  <p class="space-medium"><strong>{{ 'Client data' | translate }}</strong></p>
                  <div class="center-data">
                    <p>
                      <i class="far fa-user" aria-hidden="true"></i> {{ assistancecase.contact_name }}
                    </p>
                    <p>
                      #{{ 'Policy' | translate }}:
                      <strong>
                        {{ assistancecase.assistance_sale ? assistancecase.assistance_sale.code : 'PENDIENTE' }}
                      </strong>
                    </p>
                  </div>
                  <div class="center-data">
                    <p *ngIf="assistancecase.car_plate">
                      {{ 'Car Plate' | translate }}:
                      <strong>
                        {{ assistancecase.car_plate }}
                      </strong>
                    </p>
                  </div>
                </td>
              </tr>

              <tr class="end-card down" style="background-color: white;">
                <td colspan="3" class="end-card justify" style="height: 35px;">
                  <div class="div-left" (click)=test(assistancecase)>
                    <img alt="" class="img-space-rigth"
                      [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/clock-' + (getColorValue(assistancecase.id) || 'black') + '.svg' | company"
                      (click)="setDialogValue(assistancecase.id)">
                    <p-dialog header="{{'Management Times' | translate }}" [modal]="true"
                      [(visible)]="dialogTimer[assistancecase.id]">
                      <app-assistance-case-times-pop-up [assistancecase]="assistancecase" [filter]="filter"
                        (case)="setColorValue($event)" (client)="setColorClientValue($event)"
                        (operator)="setColorOperatorValue($event)" (dispatcher)="setColorDispatcherValue($event)"
                        (provider)="setColorProviderValue($event)">
                      </app-assistance-case-times-pop-up>
                    </p-dialog>
                    <app-assistance-case-times [assistancecase]="assistancecase" (case)="setColorValue($event)"
                      (client)="setColorClientValue($event)" (operator)="setColorOperatorValue($event)"
                      (dispatcher)="setColorDispatcherValue($event)" (provider)="setColorProviderValue($event)">
                    </app-assistance-case-times>
                  </div>

                  <!-- VISTA DESPACHADOR -->
                  <div class="div-rigth" *ngIf="isOnlyDispatcherRole">
                    <div class="a-left">
                      <!-- Si fuera Espera de asignacion -->
                      <div class="options-size"
                        *ngIf="(getStatusCase(assistancecase.id) == 'provider_pending' ? true : false) && (timeToAssignProvider[assistancecase.id] != true)">
                        <p [ngClass]="{'blue': getColorValue(assistancecase.id) == 'blue' ? true : false,
                          'red_': getColorValue(assistancecase.id) == 'red' ? true : false,
                          'yellow_': getColorValue(assistancecase.id) == 'yellow' ? true : false}">
                          {{ 'Waiting for supplier assignment' | translate }}
                          <app-progressbar-timer-negative [starttime]="assistancecase.date_start"
                            (end)="completeTimer($event,assistancecase.id)">
                          </app-progressbar-timer-negative>
                        </p>
                      </div>

                      <!-- Si se tuviera que asignar Proveedor manualmente -->
                      <div class="options-size"
                        *ngIf="(getStatusCase(assistancecase.id) == 'provider_pending' ? true : false) && (timeToAssignProvider[assistancecase.id] == true)">
                        <button type="button" class="btn btn-light btn primary-btn-assign" (click)="showModalSave()">{{
                          'assign_provider' | translate }}</button>
                      </div>

                      <!-- Si ya tuviera asigando un proveedor -->
                      <div class="options-size"
                        *ngIf="getStatusCase(assistancecase.id) == 'assign_provider' ? true : false">
                        <button type="button" class="btn btn-light btn primary-btn-coor" (click)="showModalSave()">{{
                          'Coordinate Assistance' | translate }}</button>
                      </div>

                      <!-- Si ya tuviera asigando un proveedor -->
                      <div class="options-size"
                        *ngIf="getStatusCase(assistancecase.id) == 'notify_provider' ? true : false">
                        <button type="button" class="btn btn-light btn primary-btn-coor" (click)="showModalSave()">{{
                          'Coordinate Assistance' | translate }}</button>
                      </div>

                      <!-- Si ya tuviera asigando un proveedor -->
                      <div class="options-size"
                        *ngIf="getStatusCase(assistancecase.id) == 'provider_arrived' ? true : false">
                        <button type="button" class="btn btn-light btn primary-btn-coor" (click)="showModalSave()"> {{
                          'Coordinate Assistance' | translate }}</button>
                      </div>
                    </div>
                    <div>


                      <a target="_blank" routerLink="/admin/alerts/{{assistancecase.id}}"
                        (click)="submenu_alert(assistancecase)" title="{{ 'Hallazgos' | translate }}"
                        *ngIf="!hasRole('cabin_read_only')">
                        <img alt="" class="img-space-pointer"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/notification2.svg' | company">
                      </a>

                      <a *ngIf="assistancecase.status == 2 && iAm([
                          'assistance_admin', 'supervisor','operator', 'teledoctor_agent', 'networkleader'
                        ])" class="btn btn-default btn-xs"
                        routerLink="/admin/assistance-v1/cases/{{assistancecase.id}}/bills/{{filter.status}}/{{filter.member_id}}"
                        target="_blank">
                        {{ 'Bills' | translate }}
                      </a>

                      <span *ngIf="assistancecase.status == 2
                            && !assistancecase.surveyanswered
                            && iAm(['assistance_admin', 'quality'])">
                        <span class="btn btn-xs btn-default" (click)="submenu_qa(assistancecase)">
                          {{ 'Cabin Survey' | translate }}
                        </span>
                      </span>

                      <span *ngIf="iAm([
                          'assistance_admin', 'supervisor', 'quality', 'networkleader'
                        ])">
                        <span *ngIf="assistancecase.status == 2
                            && assistancecase.rating_status != 1
                            && assistancecase.rating_status != 2" class="btn btn-xs btn-default"
                          (click)="showFeedback(assistancecase)">
                          <i *ngFor="let s of star" class="select-rating fa fa-lg fa-star-o" aria-hidden="true">
                          </i>
                        </span>
                      </span>

                      <a routerLink="/admin/assistance-v1/cases/{{assistancecase.id}}/tickets/{{filter.status}}{{ filter.member_id ? ('/' + filter.member_id) : ''}}"
                        target="_blank">
                        <img alt="" class="img-space-pointer"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/eye.svg' | company">
                      </a>
                    </div>
                  </div>

                  <!-- VISTA OPERADOR -->
                  <div class="div-rigth" *ngIf="!isOnlyDispatcherRole">
                    <!-- Si fuera Operador -->
                    <div class="a-left">
                      <!-- Si fuera pendiente por abrir -->
                      <div *ngIf="getColorValue(assistancecase.id) == 'black' ? true : false">
                        <img alt="" class="img-space-rigth right"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/warning.svg' | company">
                        <strong>{{ 'Pending to open' | translate }}</strong>
                      </div>

                      <!-- Si fuera Espera de asignacion -->
                      <div class="options-size"
                        *ngIf="(getStatusCase(assistancecase.id) == 'provider_pending' ? true : false) && (timeToAssignProvider[assistancecase.id] != true)">
                        <p [ngClass]="{'blue': getColorValue(assistancecase.id) == 'blue' ? true : false,
                          'red_': getColorValue(assistancecase.id) == 'red' ? true : false,
                          'yellow_': getColorValue(assistancecase.id) == 'yellow' ? true : false}">
                          {{ 'Waiting for supplier assignment' | translate }}
                          <app-progressbar-timer-negative [starttime]="assistancecase.date_start"
                            (end)="completeTimer($event,assistancecase.id)">
                          </app-progressbar-timer-negative>
                        </p>
                      </div>

                      <!-- Si fuera Espera de asignacion -->
                      <div class="options-size"
                        *ngIf="(getStatusCase(assistancecase.id) == 'provider_pending' ? true : false) && (timeToAssignProvider[assistancecase.id] == true)">
                        <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' |
                            translate}}:</strong>
                          <aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside>
                        </div>
                      </div>

                      <!-- Si ya tuviera asigando un proveedor -->
                      <div class="options-size"
                        *ngIf="getStatusCase(assistancecase.id) == 'assign_provider' ? true : false">
                        <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' |
                            translate}}:</strong>
                          <aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside>
                        </div>
                        <strong>{{ 'Provider' | translate }}:</strong>
                        <p class="timer-space-left">{{getProviderName(assistancecase.id)}}</p>
                      </div>

                      <div class="options-size"
                        *ngIf="getStatusCase(assistancecase.id) == 'reimbursement' ? true : false">
                        <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' |
                            translate}}:</strong>
                          <aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside>
                        </div>
                        <strong>{{ 'Provider' | translate }}:</strong>
                        <p class="timer-space-left">{{getProviderName(assistancecase.id)}}</p>
                      </div>

                      <!-- Si ya tuviera asigando un proveedor -->
                      <div class="options-size"
                        *ngIf="getStatusCase(assistancecase.id) == 'notify_provider' ? true : false">
                        <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' |
                            translate}}:</strong>
                          <aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside>
                        </div>
                        <strong>{{ 'Provider' | translate }}:</strong>
                        <p class="timer-space-left">{{getProviderName(assistancecase.id)}}</p>
                      </div>

                      <!-- Si ya tuviera asigando un proveedor -->
                      <div class="options-size"
                        *ngIf="getStatusCase(assistancecase.id) == 'provider_arrived' ? true : false">
                        <div *ngIf="getStatusCase(assistancecase.id)" class="d-inline  me-3"><strong>{{ 'State' |
                            translate}}:</strong>
                          <aside class="d-inline text-info"> {{ getStatusCase(assistancecase.id) | translate }}</aside>
                        </div>
                        <strong>{{ 'Provider' | translate }}:</strong>
                        <p class="timer-space-left">{{getProviderName(assistancecase.id)}}</p>
                      </div>
                    </div>

                    <div>
                      <a target="_blank" routerLink="/admin/alerts/{{assistancecase.id}}"
                        (click)="submenu_alert(assistancecase)" title="{{ 'Hallazgos' | translate }}"
                        *ngIf="!hasRole('cabin_read_only')">
                        <img alt="" class="img-space-pointer"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/notification2.svg' | company">
                      </a>
                      <a *ngIf="assistancecase.status == 2 && iAm([
                          'assistance_admin', 'supervisor','operator', 'teledoctor_agent', 'networkleader'
                        ])" target="_blank"
                        routerLink="/admin/assistance-v1/cases/{{assistancecase.id}}/bills/{{filter.status}}/{{filter.member_id}}"
                        title="{{ 'Bills' | translate }}">
                        <img alt="" class="img-space-pointer"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/billing_circle.svg' | company">
                      </a>


                      <a *ngIf="assistancecase.status == 2
                            && !assistancecase.surveyanswered
                            && iAm(['assistance_admin', 'quality'])" (click)="openDialogPauta(assistancecase)"
                        title="{{ 'Cabin Survey' | translate }}">
                        <img alt="" class="img-space-pointer"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/pauta_circle.svg' | company">
                      </a>




                      <!--qui se invoca el nuevo metodo de survey generica este es cuando esta contestada -->
                      <a *ngIf="assistancecase.status == 2
                      && assistancecase.evaluado" (click)="openSelectSendSurvey(assistancecase)"
                        title="{{ 'Cabin Survey' | translate }}">
                        <img class="img-space-pointer"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/star_color2.svg' | company"
                          alt="">
                      </a>

                      <a *ngIf="assistancecase.status == 2
                      && assistancecase.rating_status == 1" (click)="submenu_qa2(assistancecase)"
                        title="{{ 'Cabin Survey Old' | translate }}">
                        <img class="img-space-pointer"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/star_color2.svg' | company"
                          alt="">
                      </a>
                      <!-- aqui se invoca el nuevo metodo de survey generica este es cuando NO esta contestada-->
                      <a *ngIf="iAm([
                          'assistance_admin', 'supervisor', 'quality', 'networkleader'
                        ]) && 
                        assistancecase.status == 2
                            && assistancecase.rating_status != 1
                            && assistancecase.evaluado==false" (click)="openSelectSendSurvey(assistancecase)"
                        title="{{ 'Service Survey' | translate }}">
                        <img class="img-space-pointer"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/star_circle.svg' | company"
                          alt="">
                      </a>
                      <a routerLink="/admin/assistance-v1/cases/{{assistancecase.id}}/tickets/{{filter.status}}{{ filter.member_id ? ('/' + filter.member_id) : ''}}"
                        target="_blank">
                        <img class="img-space-pointer"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/eye.svg' | company"
                          alt="">
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <p-paginator [rows]="10" [totalRecords]="totalCount" [pageLinkSize]="10" (onPageChange)="nextPage($event)">
      </p-paginator>
    </div>
  </div>

  <!-- Vista de Cases vacia -->
  <div class="display-empty-mother" *ngIf="!isAssistanceCasesEmpty() && !showDialog">
    <div class="display-empty">
      <img
        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/assistancecases_empty.svg' | company"
        alt="">
      <div class="display-flex-column">
        <h1><strong>{{ 'Congratulations!' | translate }}</strong></h1>
        <h2>{{ 'Your procedures are up to date' | translate }}</h2>
        <button type="button" class="btn btn-light btn primary-btn mrg-tp" (click)="showModalSave()"
          *ngIf="!isAssistanceCasesEmpty()">
          {{ 'Create Assistance Case' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showDialog">
    <app-assistance-cases-form [assistancecase]="assistancecase" [states]="states" [caseLocation]="caseLocation"
      [countries]="countries" [startCount]="startCount" [newMember]="newMember" [newMemberCountry]="newMemberCountry"
      [editevent]="editevent" [reset]="createTicket" (create)="onSave($event)"
      (changeMessageNavBar)="changeMessageNavBar($event)" [messageService]="messageService"
      (memberCreate)="createMember($event)" #assistanceCasesForm>
    </app-assistance-cases-form>
  </div>
</div>



<!-- create new member -->
<p-dialog [(visible)]="memberDialog" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" (onHide)="cancelMember()">
  <ng-template pTemplate="header">
    
    {{ 'Create Client' | translate }}
  
  </ng-template>
  
  <app-member-form [member]="member" [editmember]="editmember" [status]="memberstate_flag" [countries]="countries"
    [memberLocation]="memberLocation" [requiredEmail]="false" (create)="onMemberSave($event)" (cancelEvent)="cancelMember()">
  </app-member-form>
</p-dialog>

<!-- member info -->
<p-popover #memberInfo>
  <div class="user" *ngIf="assistancecaseInfo && assistancecaseInfo.member">
    <div>
      <p>
        <strong>{{ 'Phone' | translate }}: </strong>
        <a href="tel:{{ assistancecaseInfo.phone }}">
          {{ assistancecaseInfo.phone }}
        </a>
      </p>
      <p *ngIf="assistancecaseInfo.phone2">
        <strong>{{ 'Secondary Phone' | translate }}: </strong>
        <a href="tel:{{ assistancecaseInfo.phone2 }}">
          {{ assistancecaseInfo.phone2 }}
        </a>
      </p>
      <p>
        <strong>{{ 'Address' | translate }}: </strong>
        {{ assistancecaseInfo.address }}
      </p>
    </div>
  </div>
</p-popover>

<!-- times -->
<p-popover #times>
  <div class="user" *ngIf="assistancecaseTime && assistancecaseTime.date_start">
    <div>
      {{ assistancecaseTime.date_start | daysOffset | async }}
    </div>
  </div>
</p-popover>

<!-- rating and comment -->
<p-dialog [(visible)]="showDialogFeedback" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [class.ui-dialog-titlebar]="true" [blockScroll]="true">
  <ng-template pTemplate="header">
    {{ 'Feedback' | translate }}
  </ng-template>
  

  <form class="form-horizontal" #form="ngForm" (ngSubmit)="saveFeedback()">
    <legend>{{ 'Case' | translate }}</legend>

    <div class="question">
      <div class="form-group">
        <table class="col-sm-12" aria-label="answeredtable">

          <th scope="col"></th>
          <tr>
            <td class="control-label col-sm-3">
              <label>{{ 'Answered the Call' | translate }}:</label>
            </td>
            <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
              <input type="radio" [(ngModel)]="assistancecaseFeedback.rating_status"
                (ngModelChange)="onSelectRatingStatus($event)" name="rating_status" [value]=1 required>
            </td>
            <td class="col-sm-1" style="text-align: left; cursor:pointer" (click)="onSelectRatingStatus(1)">
              {{ 'Yes' | translate }}
            </td>
            <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
              <input type="radio" [(ngModel)]="assistancecaseFeedback.rating_status"
                (ngModelChange)="onSelectRatingStatus($event)" name="rating_status" [value]=0 required>
            </td>
            <td class="col-sm-1" style="text-align: left; cursor:pointer" (click)="onSelectRatingStatus(0)">
              {{ 'No' | translate }}
            </td>
            <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
              <input type="radio" [(ngModel)]="assistancecaseFeedback.rating_status"
                (ngModelChange)="onSelectRatingStatus($event)" name="rating_status" [value]=2 required>
            </td>
            <td class="col-sm-4" style="text-align: left; cursor:pointer" (click)="onSelectRatingStatus(2)">
              {{ "Doesn't Apply" | translate }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div *ngIf="showquestions">
      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{ 'How do you rate the speed in which we attended you call?' | translate }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select class="form-control" [(ngModel)]="assistancecaseFeedback.speed_rating" name="speed_rating"
              (ngModelChange)="onSpeedRating($event)" #speed_rating required>
              <option *ngFor="let speed of ratings" [ngValue]="speed.val">
                {{ speed.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{ 'How do you rate the service in the phone call?' | translate }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select class="form-control" [(ngModel)]="assistancecaseFeedback.phone_rating" name="phone_rating"
              (ngModelChange)="onPhoneRating($event)" #phone_rating required>
              <option *ngFor="let phone of ratings" [ngValue]="phone.val">
                {{ phone.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{
              'How do you rate the arrival time of our technician to the place?'
              | translate
              }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select class="form-control" [(ngModel)]="assistancecaseFeedback.time_rating" name="time_rating"
              (ngModelChange)="onTimeRating($event)" #time_rating required>
              <option *ngFor="let time of ratings" [ngValue]="time.val">
                {{ time.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{ 'How do you rate the service given by our technician?' | translate }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select class="form-control" [(ngModel)]="assistancecaseFeedback.service_rating" name="service_rating"
              (ngModelChange)="onServiceRating($event)" #service_rating required>
              <option *ngFor="let service of ratings" [ngValue]="service.val">
                {{ service.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{
              'How much effort did it took you to get in touch with our emergency cabin and fix your problem?'
              | translate
              }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select class="form-control" [(ngModel)]="assistancecaseFeedback.effort_rating" name="effort_rating"
              (ngModelChange)="onEffortRating($event)" #effort_rating required>
              <option *ngFor="let effort of effort_ratings" [ngValue]="effort.val">
                {{ effort.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="question">
        <div class="form-group">
          <div class="col-sm-12" *ngIf="!fieldsRequired['recommendation_rating']">
            <label class="control-label question">
              {{
              'From 1 to 10 how much would you recommend the assistance to your family and friends?'
              | translate
              }}
            </label>
          </div>
          <div class="col-sm-12" style="color: red" *ngIf="fieldsRequired['recommendation_rating']">
            <label class="control-label question">
              {{
              'From 1 to 10 how much would you recommend the assistance to your family and friends?'
              | translate
              }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-offset-3 col-sm-9">
            <i *ngFor="let recommendation of rating"
              class="select-rating fa-2x fa-star fa{{recommendation < selectedRecommendation ? 's' : 'r'}}"
              (click)="selectRecommendation(recommendation)" (mouseover)='hoverRecommendation(recommendation)'
              (mouseleave)="leaveRecommendation()" aria-hidden="true">
            </i>
            <span *ngIf="hoverRecommendationValue">
              {{hoverRecommendationValue}}/10
            </span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">
          {{ 'Client Comment' | translate }}:
        </label>
        <div class="col-sm-9">
          <textarea class="form-control" [(ngModel)]="assistancecaseFeedback.member_comment" name="Comment">
          </textarea>
        </div>
      </div>

      <div class="form-group" *ngIf="showReason">
        <label class="control-label col-sm-3">
          {{ 'Reason' | translate }}:
        </label>
        <div class="col-sm-9">
          <select class="form-control" [(ngModel)]="assistancecaseFeedback.reason"
            (ngModelChange)="onSelectReason($event)" name="reason" required>
            <option *ngFor="let r of reason" value={{r.val}}>
              {{r.text | translate}}
            </option>
          </select>
        </div>
      </div>

      <div *ngFor="let service of services; let i = index">
        <legend>{{service.name}}</legend>
        <div class="form-group">
          <label class="control-label col-sm-3">
            {{ 'Rating' | translate }}:
          </label>
          <div class="col-sm-9">
            <i *ngFor="let r of rating" class="select-rating fa-star fa-2x fa{{r < service.rating ? 's' : 'r'}}"
              (click)="selectRating(r, i)" (mouseover)='hoverStarService(r, i)'
              (mouseleave)="leaveHoverStarService(r, i)" aria-hidden="true">
            </i>
            <span *ngIf="service.hoverStar">{{service.hoverStar}}/10</span>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-3">{{ 'Comment' | translate }}:</label>
          <div class="col-sm-9">
            <textarea class="form-control" [(ngModel)]="service.comment" name="Comment_{{i}}">
            </textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-3 col-sm-9 div-btn-right">
        <button type="button" class="btn btn-default btn-sm" (click)="onCancel()">
          {{ 'Cancel' | translate }}
        </button>
        <button *ngIf="showquestions" type="submit" class="btn btn-primary btn-sm"
          [disabled]="form.form.invalid || form.form.pending || disabled">
          {{ 'Save' | translate }}
        </button>
        <button *ngIf="!showquestions" type="submit" class="btn btn-primary btn-sm" [disabled]="disabled">
          {{ 'Save' | translate }}
        </button>
      </div>
    </div>
  </form>
</p-dialog>

<!-- Dialog filter -->
<p-dialog [(visible)]="showDialogFilter" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [class.ui-dialog-titlebar]="true" [blockScroll]="true" [style]="{width: '80vw'}">
  <ng-template pTemplate="header">
    {{ 'Filters' | translate }}
  </ng-template>
  
  <div class="filer-div-space-display row">
    <div class="filer-div-space col-6">
      <div class="filter-div-display">
        <div class="filer-div-md">
          <label>
            {{ 'Case Number' | translate}}
          </label>
          <input type="number" name="case_id" class="form-control" min="0" (ngModelChange)="onSelectCaseId($event)"
            [ngModel]="filter.id" #case_id="ngModel">
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Policy' | translate}}
          </label>
          <input name="code" class="form-control" min="0" (ngModelChange)="onSelectPolicy($event)"
            [ngModel]="filter.code" #code="ngModel">
        </div>
      </div>
      <div class="filter-div-display">
        <div class="filer-div-md">
          <label>
            {{ 'Sinister Number' | translate}}
          </label>
          <input name="sinister_claim" class="form-control" (ngModelChange)="onSelectSinisterClaim($event)"
            [ngModel]="filter.sinister_claim" #sinister_claim="ngModel">
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Car Plate' | translate}}
          </label>
          <input name="car_plate" class="form-control" (ngModelChange)="onSelectCarPlate($event)"
            [ngModel]="filter.car_plate" #car_plate="ngModel">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="filter-item">
            <label>
              {{ 'Serie' | translate}}
            </label>
            <input name="serial" class="form-control" min="0" (ngModelChange)="onSelectSerial($event)"
              [ngModel]="filter.serial" #serial="ngModel">
          </div>
        </div>
      </div>
      <div class="filter-div-display column w-100">
        <label>
          {{ 'From' | translate }}
        </label>
        <div class="DateFilters">
          <app-select-date [notSetDate]="true" [editdate]="filter.from_date" (seteditday)="onSelectFromDate($event)">
          </app-select-date>
        </div>
      </div>

      <div class="filter-div-display column w-100">
        <label class="lbl-top-margin">
          {{ 'To' | translate }}
        </label>
        <div class="DateFilters">
          <app-select-date [notSetDate]="true" [editdate]="filter.to_date" (seteditday)="onSelectToDate($event)">
          </app-select-date>
          <strong class="text-danger" *ngIf="dates_valid === false">
            {{ 'The maximum range allowed is 31 days' | translate }}
          </strong>
        </div>
      </div>
    </div>
    <div class="filer-div-space col-6">
      <div class="filter-div-display">
        <div class="filer-div-md">
          <label>
            {{ 'Case status' | translate}}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.ticket_status"
            [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">{{ 'Any Status' | translate }}</option>
            <option [ngValue]="1">{{ 'Assign Service' | translate }}</option>
            <option [ngValue]="2">{{ 'Assign Provider' | translate }}</option>
            <option [ngValue]="3">{{ 'Notify to customer' | translate }}</option>
            <option [ngValue]="4">{{ 'Provider Arrived' | translate }}</option>
            <option [ngValue]="50">{{ 'Arrival registered from the app' | translate }}</option>
            <option [ngValue]="15">{{ 'reimbursement' | translate }}</option>
          </select>
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Sort' | translate}}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.sorting" [ngModelOptions]="{standalone: true}">
            <option selected [ngValue]="1">{{ 'Descendent' | translate }}</option>
            <option [ngValue]="2">{{ 'Ascendent' | translate }}</option>
          </select>
        </div>
      </div>

      <div class="filter-div-display">
        <div class="filer-div-md">
          <label>
            {{ 'Status' | translate }}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.status" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="0">{{ 'Any Status' | translate }}</option>
            <option [ngValue]="1">{{ 'Open' | translate }}</option>
            <option [ngValue]="2">{{ 'Closed' | translate }}</option>
          </select>
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Country' | translate }}
          </label>
          <div>
            <select class="form-control input-sm" (ngModelChange)="onSelectCountryFilter($event)"
              [(ngModel)]="filter.country_id" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">---</option>
              <option *ngFor="let country of countries" [ngValue]="country.id">
                {{ country.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="filter-div-display">

        <div class="filer-div-md">
          <label>
            {{ 'State of Republic' | translate }}
          </label>
          <div>
            <select class="form-control input-sm" (ngModelChange)="onSelectCountryStateFilter($event)"
              [(ngModel)]="filter.country_state_id" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">---</option>
              <option *ngFor="let country_state of country_states" [ngValue]="country_state.id">
                {{ country_state.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Service' | translate }}:
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.service_id" name="service">
            services_filter
            <option [ngValue]="null">---</option>
            <option *ngFor="let service of services_filter" value={{service.id}}>
              <span>{{service.name}}</span>
            </option>
          </select>
        </div>
      </div>

      <div class="filter-div-display">
        <div class="filer-div-md">
          <label>
            {{ 'Product' | translate }}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.assistance_id"
            (ngModelChange)="onSelectProduct($event)" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">---</option>
            <option *ngFor="let product of products" [ngValue]="product.id">
              {{ product.id }} - {{ product.name }}
            </option>
          </select>
        </div>
        <div class="filer-div-md">
          <label>
            {{ 'Assistance Plan' | translate }}
          </label>
          <select class="form-control input-sm" [(ngModel)]="filter.assistance_plan_id"
            (ngModelChange)="onSelectProductPlan($event)" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">---</option>
            <option *ngFor="let plan of assistanceplans" [ngValue]="plan.id">
              {{ plan.id }} - {{ plan.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="filter-div-display">
        <div class="filer-div-md">
          <label>
            {{ 'Salesman' | translate }}
          </label>
          <input name="serial" class="form-control" min="0" (ngModelChange)="onSelectSalesman($event)"
            [ngModel]="filter.salesman" #serial="ngModel">

        </div>


      </div>



    </div>

    <div class="filer-div-space col-12">

      <div class="row my-3">
        <div class="col">
          <div *ngIf="!myTickets" class="filter-item">
            <label class="lbl-top-margin">
              {{ 'Dispatcher' | translate }}
            </label>

            <p-autocomplete name="dispatcher_array_pchip" [(ngModel)]="dispatcher_array"
              placeholder="{{ 'Enter a dispatcher and press enter' | translate }}" [unique]="true"
              styleClass="ng-chips" [multiple]="true" [suggestions]="[]">
            </p-autocomplete>


          </div>
        </div>
      </div>

      <div class="row my-3">
        <div class="col">
          <div *ngIf="!myTickets" class="filter-item">
            <label class="lbl-top-margin">
              {{ 'Operator' | translate }}
            </label>

            <p-autocomplete name="operator_array_pchip" [(ngModel)]="operator_array"
              placeholder="{{ 'Enter a operator and press enter' | translate }}" [unique]="true"
              styleClass="ng-chips" [multiple]="true" [suggestions]="[]">
            </p-autocomplete>

          </div>
        </div>
      </div>

      <div class="row my-3" *ngIf="filter.country_id">

        <div class="col">
          <div *ngIf="!myTickets" class="filter-item">
            <label class="lbl-top-margin">
              {{ 'Assistance Provider' | translate }}
            </label>

            <app-assistance-provider-select [country_id]="filter.country_id"
              (onSelect)="onSelectAssistanceProvider($event)" (onClear)="onClearSelectAssistanceProvider()"
              (onQuery)="onQueryAssistanceProvider($event)">
            </app-assistance-provider-select>
          </div>
        </div>
      </div>



      <div class="row my-3">
        <div class="col">
          <div *ngIf="!myTickets" class="filter-item">
            <label>
              {{ 'Client Name/ID' | translate}}
            </label>
            <app-members-search (onSelect)="onSelectMemberFilter($event)" (onClear)="onClearSelectMember()"
              [newMember]="newMember" [assistanceCase]="true" (onQuery)="onQueryMember($event)"
              [style]="{'width':'30%'}" [placeholder]="'Member'">
            </app-members-search>
          </div>
        </div>
      </div>


    </div>

  </div>
  <br>
  <hr class="hr-height">
  <div class="filer-div-end">
    <button class="btn btn-light btn primary-btn" [disabled]="disabled" (click)="filterAssistanceCase()"
      style="width: 15rem; font-weight: bold;">
      {{ 'Filter' | translate }}
    </button>
  </div>

</p-dialog>


<!-- Download Report -->
<p-dialog [(visible)]="showDialogDownloadReport" [modal]="true" [draggable]="false" [blockScroll]="true"
  [style]="{width: '25vw'}">
  <ng-template pTemplate="header">
    {{ 'Download Report' | translate }}
  </ng-template>
  
  <form class="form-horizontal row" (ngSubmit)="saveDownloadReport()">
    <div class="form-group col-md-12">
      <label class="control-label col-sm-12">
        <strong>{{ 'File Type' | translate }}</strong>
      </label>
      <div class="col-sm-12">
        <select class="form-control" [(ngModel)]="downloadReport.file_type" name="file_type">
          <option value="xlsx">XLSX</option>
          <option value="csv">CSV</option>
        </select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="w-100 text-center mt-2">
        <button type="submit" class="btn btn-light btn primary-btn">
          {{ 'Save' | translate }}
        </button>
      </div>
    </div>
  </form>
</p-dialog>


<!-- Alert Dialog-->
<p-dialog [(visible)]="showDialogAlert" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [positionTop]="100">
  <ng-template pTemplate="header">
    
    {{ 'Alert' | translate }}
  
  </ng-template>
  
  <div *ngIf="temp_assistance_case">

    <span>
      <span class="btn btn-light btn primary-btn" (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_CABIN_SURVEY
    )">
        {{ 'Insert Alert' | translate }}
      </span>
    </span>

    <span>
      <span class="btn btn-light btn primary-btn" (click)="showsubSurvey(
    groupClass.ASSISTANCE_CASE_CABIN_SURVEY
  )">
        {{ 'Alerts' | translate }}
      </span>
    </span>
  </div>

</p-dialog>


<!-- QA Dialog -->
<p-dialog [(visible)]="showDialogQA" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [positionTop]="100">
  <ng-template pTemplate="header">
    
    {{ 'Cabin Survey' | translate }}
  
  </ng-template>
  
  <div *ngIf="temp_assistance_case">
    <span
      *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) == -1 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
      <span class="btn btn-light btn primary-btn" (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_CABIN_SURVEY
    )">
        {{ 'Cabin Process' | translate }}
      </span>
    </span>

    <span
      *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) == -1 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
      <span class="btn btn-light btn primary-btn" (click)="showsubSurvey(
    groupClass.ASSISTANCE_CASE_DISPATCH_SURVEY
  )">
        {{ 'Dispatch Process' | translate }}
      </span>
    </span>

    <span
      *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) == -1 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
      <span class="btn btn-light btn primary-btn" (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_COMPLETE_SURVEY
  )">
        {{ 'Complete Process (Cabin + Dispatch)' | translate }}
      </span>
    </span>


    <span>
      <span class="btn btn-light btn primary-btn"
        *ngIf="information_id.indexOf(temp_assistance_case.services[0].id) >= 0 " (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_INFORMATION_SURVEY
    )">
        {{ 'Information' | translate }}
      </span>
    </span>




    <span
      *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) >= 0 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
      <span class="btn btn-light btn primary-btn" (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_CABIN_SURVEY_AMBULANCE
    )">
        {{ 'Cabin Process (ambulance)' | translate }}
      </span>
    </span>

    <span
      *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) >= 0 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
      <span class="btn btn-light btn primary-btn" (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_DISPATCH_SURVEY_AMBULANCE
    )">
        {{ 'Dispatch Process (ambulance)' | translate }}
      </span>
    </span>

    <span
      *ngIf="ambulance_id.indexOf(temp_assistance_case.services[0].id) >= 0 && information_id.indexOf(temp_assistance_case.services[0].id) == -1">
      <span class="btn btn-light btn primary-btn" (click)="showsubSurvey(
      groupClass.ASSISTANCE_CASE_COMPLETE_SURVEY_AMBULANCE
    )">
        {{ 'Complete Process (ambulance)' | translate }}
      </span>
    </span>

  </div>

</p-dialog>
<!-- Survey Dialog -->
<p-dialog [(visible)]="showSurcveyDialog" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [positionTop]="100">
  <ng-template pTemplate="header">
    
    {{ 'Survey Answers' | translate }}
  
  </ng-template>
  
  <app-individual-case-survey-form [editdata]="editsurvey" [isTD]="isTD" [type_case]="type_case"
    [survey_type]="survey_type" (update)="onUpdateSurvey($event)" (cancelEvent)="onCancel()" #individualSurvey>
  </app-individual-case-survey-form>
</p-dialog>



<!-- Survey Dialog 2 -->
<p-dialog [(visible)]="showDialogQA2" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [positionTop]="100">
  <ng-template pTemplate="header">
    
    {{ 'Survey Answers OLD' | translate }}
  
  </ng-template>
  
  <div class="form-group">
    <div class="col-sm-12">
      <label *ngIf="questions_officer && questions_officer[0]" class="control-label question">
        {{ 'Channel' | translate}}: {{channel[questions_officer[0][0].answered_from]}}
      </label>
    </div>
  </div>
  <div class="form-group">
    <table class="col-sm-12" aria-label="fittable">
      <th scope="col"></th>
      <tr>
        <td class="control-label col-sm-3">
          <label>{{ 'Doesn\'t Fit Criteria' | translate }}:</label>
        </td>
        <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
          <input type="radio" [ngModel]="fit_criteria_" name="criteria_" [value]="1" disabled>
        </td>
        <td class="col-sm-2" style="text-align: left;">
          {{ 'Yes' | translate }}
        </td>
        <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
          <input type="radio" [ngModel]="fit_criteria_" name="criteria_" [value]="0" disabled>
        </td>
        <td class="col-sm-3" style="text-align: left;">
          {{ 'No' | translate }}
        </td>
        <td class="col-sm-2"></td>
      </tr>
    </table>
  </div>
  <div class="form-group" *ngIf="not_apply_details && not_apply_details.tip1>1">
    <div>
      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{ 'Description 1' | translate}}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select class="form-control" [(ngModel)]="not_apply_details.tip1" name="tip1" disabled>
              <option value="2">{{ 'Negative Contact' | translate }}</option>
              <option value="3">{{ 'Cabin Inconsistencies' | translate }}</option>
              <option value="4">{{ 'Consolidated services survey' | translate }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="question">
        <div class="form-group">
          <div class="col-sm-12">
            <label class="control-label question">
              {{ 'Description 2' | translate }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <select class="form-control" [(ngModel)]="not_apply_details.tip2" name="tip2" disabled>
              <option value="3">{{ 'Voicemail' | translate }}</option>
              <option value="4">{{ 'Call Back' | translate }}</option>
              <option value="5">{{ 'Number does not exist' | translate }}</option>
              <option value="6">{{ 'Out of Service Number' | translate }}</option>
              <option value="7">{{ 'Wrong number' | translate }}</option>
              <option value="8">{{ 'Assistance user not located' | translate }}</option>
              <option value="9">{{ 'Does not want to answer the survey' | translate }}</option>
              <option value="10">{{ 'Does not connect the call' | translate }}</option>
              <option value="11">{{ 'Affiliate is Abroad' | translate }}</option>
              <option value="12">{{ 'Ticket canceled' |translate }}</option>
              <option value="13">{{ 'Ticket canceled by provider' |translate }}</option>
              <option value="14">{{ 'Coverage information' |translate }}</option>
              <option value="15">{{ 'Cabin Performs Test' |translate }}</option>
              <option value="16">{{ 'Billing ticket' |translate }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="form-group">
    <div class="col-sm-12">
      <label *ngIf="questions_officer && questions_officer[0]" class="control-label question">
        {{ 'Comment' | translate}}: {{questions_officer[0][0].approved_comment}}
      </label>
    </div>
  </div>

  <div *ngIf="false">
    <div class="question" *ngFor="let question of questions_officer">
      <div class="form-group">
        <div class="col-sm-12">
          <label class="control-label question">
            {{question[1].question}}
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <select class="form-control">
            <option>
              {{(question[1].id == 180 ) ? question[0].value : answers1[question[0].value]}}
            </option>

          </select>

        </div>
      </div>
      <br>
    </div>
  </div>

  <div *ngIf="questions_officer_update" class="question">
    <h1>para aplicar</h1>
    <div class="question" *ngFor="let question of questions_officer_update['0'].questions">
      <div class="form-group">
        <div class="col-sm-12">
          <label class="control-label question">
            {{question.question}}
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <select class="form-control" [(ngModel)]=question.respuesta.value>
            <ng-container *ngFor="let suggestedAnswer of question.suggestedAnswers">

              <option selected *ngIf="suggestedAnswer.id == question.respuesta.suggested_value_id"
                [ngValue]="suggestedAnswer.value">
                {{(questions_id_sug.indexOf(suggestedAnswer.id) == -1 ) ? answers_2[suggestedAnswer.value] :
                suggestedAnswer.value }}
              </option>
              <option *ngIf="suggestedAnswer.id != question.respuesta.suggested_value_id"
                [ngValue]="suggestedAnswer.value">
                {{(questions_id_sug.indexOf(suggestedAnswer.id) == -1 ) ? answers_2[suggestedAnswer.value] :
                suggestedAnswer.value }}
              </option>

            </ng-container>

          </select>
        </div>
      </div>
      <br>
    </div>
    <br>

  </div>
  <ng-container *ngIf="!(not_apply_details && not_apply_details.tip1>1)">
    <div class="form-group">
      <div class="col-sm-12">
        <label class="control-label question">
          {{'comment client' | translate}}:
        </label>
      </div>
    </div>
    <div class="col-sm-12">
      <textarea class="form-control" [(ngModel)]="comment_user" name="Comment2" readonly>
      </textarea>
    </div>

    <div *ngIf="iAm(['risk_officer'])">
      <table class="col-sm-12" aria-label="aplicatable">

        <th scope="col"></th>
        <tr>
          <td class="control-label col-sm-3">
            <label>{{ 'Apply2' | translate }}:</label>
          </td>
          <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
            <input type="radio" [ngModel]="fit_criteria" name="criteria" (click)="aplica(1)" [value]=1>
          </td>
          <td class="col-sm-2" style="text-align: left; cursor:pointer" (click)="aplica(1)">
            {{ 'Yes' | translate }}
          </td>
          <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
            <input type="radio" [ngModel]="fit_criteria" name="criteria" (click)="aplica(0)" [value]=0>
          </td>
          <td class="col-sm-3" style="text-align: left; cursor:pointer" (click)="aplica(0)">
            {{ 'No' | translate }}
          </td>
          <td class="col-sm-2"></td>
        </tr>
      </table>

      <div class="form-group">
        <label class="control-label col-sm-3">
          {{ 'Comment' | translate }}:
        </label>
        <div class="col-sm-9">
          <textarea class="form-control" [(ngModel)]="approved_comment" name="Comment">
          </textarea>
        </div>
      </div>
    </div>

    <div *ngIf="iAm(['risk_officer'])">
      <table class="col-sm-12" aria-label="questionsvalidatetable">

        <th scope="col"></th>
        <tr>
          <td class="control-label col-sm-3">
            <label>{{ 'Questions validated with client' | translate }}:</label>
          </td>
          <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
            <input type="radio" [ngModel]="aplica_update" name="aplica_update"
              (click)="aplica_update_question(1,temp_assistance_case)" [value]=1>
          </td>
          <td class="col-sm-2" style="text-align: left; cursor:pointer"
            (click)="aplica_update_question(1,temp_assistance_case)">
            {{ 'Yes' | translate }}
          </td>
          <td class="col-sm-1" style="text-align: right; padding-right: 0px;">
            <input type="radio" [ngModel]="aplica_update" name="aplica_update"
              (click)="aplica_update_question(0,temp_assistance_case)" [value]=0>
          </td>
          <td class="col-sm-3" style="text-align: left; cursor:pointer"
            (click)="aplica_update_question(0,temp_assistance_case)">
            {{ 'No' | translate }}
          </td>
          <td class="col-sm-2"></td>
        </tr>
      </table>

      <div class="form-group">
        <label class="control-label col-sm-3">
          {{ 'Comment' | translate }}:
        </label>
        <div class="col-sm-9">
          <textarea class="form-control" [(ngModel)]="approved_comment_update" name="Comment2">
          </textarea>
        </div>
      </div>
    </div>
  </ng-container>
  <br>
  <br>
  <button *ngIf="iAm(['risk_officer']) && !(not_apply_details && not_apply_details.tip1>1)"
    [disabled]="disable_pauta_aplica2" class="btn btn-success btn-sm btn-right" (click)="aplica2()">
    {{ 'Save' | translate }}
  </button>
</p-dialog>



<!-- NUEVO DIALOG PARA ENCUESTAS-->

<p-dialog [style]="{'width':'1200px'}" width="1200" header="{{ 'Send Survey' | translate }}" [(visible)]="open"
  [responsive]="true" [modal]="true">

  <app-select-send-survey-method [phone]="customer_phone" *ngIf="open" [survey_id]="id_survey"
    [reference_number]="currentProcessId" [email]="customer_email" [country_id]="country_id"
    [client_name]="customer_name" [survey_type]="20"></app-select-send-survey-method>

</p-dialog>



<!-- NUEVO DIALOG PARA PAUTAS-->

<p-dialog [style]="{'width':'1200px'}" width="1200" header="{{ 'Pauta' | translate }}" [(visible)]="open_modal_pauta"
  [responsive]="true" [modal]="true">

  <app-select-method-pauta *ngIf="open_modal_pauta" [reference_number]="currentProcessIdPauta" [pauta_type]="20"
    [country_id]="country_id" [sponsor_id]="sponsor_id" [service_id]="service_id"
    [category_id]="category_id"></app-select-method-pauta>

</p-dialog>